
























import { plainToInstance } from 'class-transformer'
import { snakeCase } from 'lodash'
import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { ErrorChannelInfo, SuccessChannelInfo } from '../../../../../../../../../../models/CheckChannels/CheckChannels'
import ChannelsInfoHelper from '../../../../../../Helpers/ChannelsInfoHelper'
import { KickActionProxy } from '../../../logic/Actions/KickAction/KickActionProxy'
import { ActionNodeProps } from '../../../logic/types'

@Component({
  data() {
    return {
      snakeCase
    }
  }
})
export default class KickActionNode extends Vue {
  @Prop() action!: KickActionProxy

  @Prop() i18n!: i18n

  @Prop() targets!: ActionNodeProps['targets']

  get beautifyChannels() {
    return this.action.action.targets.map(id => {
      const target = this.targets().find(t => t.id === id)

      if (target) {
        return target.title
      }

      const channel = ChannelsInfoHelper.GetChannel(id!.toString())

      if (channel) {
        if (!channel?.status) {
          return plainToInstance(ErrorChannelInfo, channel).value
        } else {
          return plainToInstance(SuccessChannelInfo, channel).info.title
        }
      } else {
        return id
      }
    })
  }
}
